<app-main-container
  header="Validación de identidad"
  subheader="Autorización manejo de datos personales y centrales de riesgos"
>
  <ng-container
    *ngIf="enviarWs.intentosActuales > 0 || bloqueado; else waitingForClient"
  >
    <p>
      Confirma la respuesta del solicitante en WhatsApp. Haz clic en “Validar
      respuesta cliente”. <br />
      Si la respuesta fue “Autorizo” el proceso continuará, si eligió “No
      Autorizo” la carpeta será rechazada.
    </p>

    <div class="d-flex justify-content-start align-items-center gap-2">
      <strong
        *ngIf="
          (enviarWs.intentosActuales > 0 || bloqueado) &&
          !manualValidationStarted
        "
        >¿No fue recibido el mensaje de WhatsApp?</strong
      >

      <!-- En retoma, se desactiva el enlace "Reenviar mensaje" y aparece el contador -->
      <a
        *ngIf="!bloqueado && enviarWs.intentosActuales > 0"
        class="link-underline"
        role="button"
        (click)="openDialogSend()"
      >
        Reenviar mensaje
      </a>

      <!-- Cuando bloqueado = true (retoma en progreso), mostramos este texto -->
      <span
        *ngIf="bloqueado && !manualValidationStarted"
        [ngStyle]="{
          'pointer-events': bloqueado ? 'none' : 'auto',
          color: bloqueado ? '#10AEEF' : '#10AEEF',
          opacity: bloqueado ? '.3' : '1'
        }"
      >
        Reenviar mensaje <strong>{{ tiempoRestante }}</strong
        >s
      </span>

      <!-- (Opcional) Si quieres manejar el caso “sin intentos WS ni OTP”, 
           puedes reactivarlo aquí, pero ese fragmento estaba comentado. -->
      <!--
      <span
        *ngIf="!bloqueado && enviarWs.intentosActuales === 0"
        class="text-danger"
      >
        Has agotado todos los intentos de envío.
      </span>
      -->
    </div>
  </ng-container>

  <ng-template #waitingForClient>
    <p>
      Confirma la respuesta del solicitante en WhatsApp. Haz clic en “Validar
      respuesta cliente”. <br />
      Si la respuesta fue “Autorizo” el proceso continuará, si eligió “No
      Autorizo” la carpeta será rechazada.
    </p>
  </ng-template>

  <div class="d-flex justify-content-start align-items-start gap-2 mt-4">
    <button-look-feel
      color="secondary"
      (click)="startValidationPollingLimited()"
      [disabled]="bloqueado || manualValidationStarted"
      [loading]="isLoading"
    >
      Validar respuesta cliente
    </button-look-feel>
    <!-- <div class="d-flex justify-content-center" *ngIf="showAdvertencia">
      <app-advertencias [color]="colorAdvertencia">{{
        textoAdvertencia
      }}</app-advertencias>
    </div> -->
  </div>
  <div
    class="d-flex justify-content-start align-items-start"
    *ngIf="showAdvertencia"
  >
    <app-advertencias [color]="colorAdvertencia">{{
      textoAdvertencia
    }}</app-advertencias>
  </div>
</app-main-container>
